import styled from 'styled-components';

export const ContainerModal = styled.div`
  display: flex;
  width: 560px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  background: #fff;

  /* 03 */
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.14),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
`;

export const HeaderModal = styled.div`
  display: flex;
  padding: 5px 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Takeat-Colors-Yellow-Variations-00, #FFF8EB);

  svg {
    width: 36px;
    height: 36px;
  }
`;

export const TextHeader = styled.span`
  color: #000;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TextBody = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;

  strong {
    color: #4D4D4C;
  }
`;

export const FooterModal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  span {
    color: var(--Takeat-Colors-Neutrals-Black-01, #222);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.37);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;
